export const SupportLink = () => {
  return (
    <a className="text-stone-300 underline" href="mailto:support@usecanyon.com">
      support@usecanyon.com
    </a>
  )
}
